module.exports = __webpack_public_path__ + "static/media/kualaLumpur.4ea90f9b.svg";